(function($) {

    $.fn.catalog = function (options) {

        var $elem = this;

        var settings = $.extend({
            catalog_api: '/api/catalog',
            width: 720,
            height: 450,
            page: null,
            query: null
        }, options);

        var $row_template = $elem.find('.catalog-song').clone();

        var html = $elem.html();
        var $modal = $(html).modal({ width: settings.width, height: settings.height });

        $modal.on('click', '.catalog-song-add', function() {
            var $song = $(this).parents('.catalog-song');

            var song = {
                'slug': $song.data('slug'),
                'artist': $song.find('.catalog-song-artist').text(),
                'title': $song.find('.catalog-song-title').text(),
                'duration': $song.data('duration')
            };

            settings.callback(song, settings.page, settings.query);
            $modal.close();
        });

        $modal.on('click', '.catalog-song-play', function() {
            var $link = $(this);

            if($link.hasClass('playing')) {
                stopSong($link);
            } else {
                playSong($link);
            }
        });


        var initial_url = settings.catalog_api;
        var initial_vars = [];
        if(settings.page) initial_vars.push('page='+settings.page);
        if(settings.query) {
            initial_vars.push('q=' + settings.query);
            $modal.find('.catalog-search .catalog-query').val(settings.query);
        }
        if(initial_vars.length > 0) initial_url += '?' + initial_vars.join('&');

        console.log('URL', initial_url);

        $.get(initial_url, processResult);

        $('.catalog-search').submit(function(e) {
            e.preventDefault();
            var q = $(this).find('.catalog-query').val();
            settings.query = q;
            settings.page = null;
            $.get(settings.catalog_api + '?q=' + q, processResult);
        });

        $('.catalog-submit').click(function(e) {
            e.preventDefault();
            $('.modal-content .catalog-search').submit();
        });


        function processResult(result) {

            $('.modal-content .catalog-song').remove();
            $next = $('.catalog-next');
            $next.hide();
            $prev = $('.catalog-prev');
            $prev.hide();
            $noresults = $('.catalog-no-results');

            if(result.data.length > 0) {
                $noresults.hide();
                $.each(result.data, function (i, v) {
                    displaySong(v);
                });
            } else {
                $noresults.show();
            }

            $audio = $modal.find('audio');
            if($audio.length > 0) {
                var $playing = $modal.find('.catalog-song-play');

                $playing.each(function(i, v) {
                    if($(v).data('sample') == $audio.data('playing')) {
                        $(v).addClass('playing');
                        $(v).find('.fa').removeClass('fa-play').addClass('fa-pause');
                    }
                });
            }

            if(result.prev_page_url) {
                $prev.off('click');
                $prev.show();
                $prev.click(function(e) {
                    e.preventDefault();
                    settings.page = (result.current_page - 1);
                    $.get(result.prev_page_url, processResult);
                });
            }

            if(result.next_page_url) {
                $next.off('click');
                $next.show();
                $next.click(function(e) {
                    e.preventDefault();
                    settings.page = (result.current_page + 1);
                    $.get(result.next_page_url, processResult);
                });
            }
        }


        function displaySong(data) {
            var $song = $row_template.clone();
            $song.find('.catalog-song-artist').html(data.artist);
            $song.find('.catalog-song-title').html(data.title);
            $song.find('.catalog-song-duration').html(secondsToString(data.upload.duration));
            $song.data('duration', data.upload.duration);
            $song.data('slug', data.upload.slug);

            if(data.sample_url) {
                $song.find('.catalog-song-play').data('sample', data.sample_url);
            } else {
                $song.find('.catalog-song-play i').hide();
            }

            $('.modal-content .catalog-results').append($song);
        }


        function secondsToString(seconds) {
            var mins = Math.floor(seconds / 60);
            seconds = seconds % 60;
            seconds = ("0" + seconds).slice(-2);
            return mins + ':' + seconds;
        }

        function stopSong() {
            var $playing = $modal.find('.catalog-song-play.playing');
            $playing.removeClass('playing');
            $playing.find('.fa').removeClass('fa-pause').addClass('fa-play');
            $modal.find('audio').remove();
        }


        function playSong($link) {
            stopSong();

            var $audio = $('<audio></audio>');
            $modal.append($audio);
            $audio.append('<source src="'+$link.data('sample')+'" type="audio/mpeg">');
            $audio.data('playing', $link.data('sample'));

            $link.addClass('playing');
            $link.find('.fa').removeClass('fa-play').addClass('fa-pause');
            $audio.get(0).play();
        }


    };

}( jQuery ));